/*
  tabLOVAS — Hızlı bakış penceresi düzeltmeleri
  13 Ağustos 2026

  Neden gerekli: hızlı bakış içeriği sayfaya innerHTML ile enjekte ediliyor,
  bu yüzden içindeki <script> etiketleri ÇALIŞMIYOR. Boyut etiketlerini
  ("120x80 ( Çok Satan )") ikiye ayırma işini bu yüzden dışarıdan,
  MutationObserver ile yapıyoruz.

  Ne yapar: her boyut düğmesinde parantez içindeki ifadeyi ayırıp küçük altın
  bir rozete alır. Ürün sayfasında yaptığımız düzenlemenin aynısı.
  Ekran okuyucu için duran gizli metne dokunulmaz.

  GERİ ALMA: bu dosyayı sil + theme.liquid'deki script satırını kaldır.
*/
(function () {
  "use strict";

  function etiketleriAyir(kap) {
    var etiketler = kap.querySelectorAll(
      ".product-form__input.radio--swatch > label"
    );
    for (var i = 0; i < etiketler.length; i++) {
      var l = etiketler[i];
      if (l.querySelector(".qv-boyut-rozet")) continue;

      var dugum = null;
      for (var j = 0; j < l.childNodes.length; j++) {
        var n = l.childNodes[j];
        if (n.nodeType === 3 && n.nodeValue.indexOf("(") !== -1) {
          dugum = n;
          break;
        }
      }
      if (!dugum) continue;

      var ham = dugum.nodeValue;
      var ac = ham.indexOf("(");
      var kapa = ham.indexOf(")");
      if (ac === -1) continue;

      var boyut = ham.slice(0, ac).trim();
      var rozet = ham
        .slice(ac + 1, kapa === -1 ? ham.length : kapa)
        .trim();
      if (!boyut || !rozet) continue;

      dugum.nodeValue = boyut;
      var span = document.createElement("span");
      span.className = "qv-boyut-rozet";
      span.textContent = rozet;
      dugum.parentNode.insertBefore(span, dugum.nextSibling);
    }
  }

  var sarmal = null;
  function baslat() {
    sarmal = document.getElementById("quickViewWrapper");
    if (!sarmal) return;
    var gozlemci = new MutationObserver(function () {
      /* içerik yenilendiğinde (yeni ürün açıldığında) tekrar çalışsın */
      etiketleriAyir(sarmal);
    });
    gozlemci.observe(sarmal, { childList: true, subtree: true });
    etiketleriAyir(sarmal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", baslat);
  } else {
    baslat();
  }
})();
